import { getData } from '../utils/data.js';
export const DeviceMessageKind = {
    SETUP: 'setup',
    TRAPPING_STATUS: 'trapping-status',
    MEASURE_VOLTAGE: 'measure-voltage',
};
export const deviceMessageConverter = {
    fromFirestore(snap, op) {
        return getData(snap, op);
    },
    toFirestore(_) {
        return {};
    },
};
//# sourceMappingURL=deviceMessage.js.map